export default function deleteItem(array, index) {
  if (!Array.isArray(array)) return array;
  const newArray = [...array];
  if (index < 0 || index >= newArray.length) return array;
  
  newArray.splice(index, 1);
  return newArray;
}
